import { getIconByCssClass } from "../elements/icons/index.js";

/**
 * Convert the name of an existing icon to the version 5 of Fontawesome.
 * If the icon is not in the names mapping, it formats to the standard
 * `fas fa-iconName`.
 */
export function convertCompanyTypeIconNameToIcon(icon) {
	const mapping = {
		"area-chart": "fas fa-chart-area",
		"building-o": "far fa-building",
		cab: "fas fa-taxi",
		"hospital-o": "far fa-hospital",
		hotel: "fas fa-bed",
		pagelines: "fab fa-pagelines",
	};

	const cssClass = mapping[icon] || `fas fa-${icon}`;
	return getIconByCssClass(cssClass);
}
